import { ErrorPropsI } from "./Error.props";
import styles from "./Error.module.scss";
import { memo, useEffect, useState } from "react";
import { makeNotifs } from "@utils/makeNotifs";

export type ErrorType = {
  fill?: boolean;
  match?: boolean;
  length?: boolean;
  terms?: boolean;
  password?: boolean;
  name?: boolean;
  add_pool_setting__some_errors?: boolean;
  ownError?: string[];
};

function Error({ errors }: ErrorPropsI) {
  const notifs = makeNotifs();
  const [msgs, setMsgs] = useState<string[]>([]);

  useEffect(() => {
    const m: string[] = [];
    for (let err in errors) {
      if (err === "ownError") {
        m.push(...(errors[err] as string[]));
        break;
      }
      const key = err as keyof typeof notifs.errors;
      m.push(notifs.errors[key]);
    }
    setMsgs(m);
  }, [errors]);

  return (
    <div className={styles.wrapper}>
      {msgs.map((msg, i) => (
        <p className={styles.error} key={i}>
          {msg}
        </p>
      ))}
    </div>
  );
}

export default memo(Error);
